import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "assets/icons/CloseIcon";
import Form from "components/form/Form";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import UploadButton from "./components/UploadButton";

type CandidatesFormInputs = {
  cvFiles: { file: File }[];
};

export type UploadCandidateModalProps = {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (files: File[]) => void;
};

const UploadCandidateModal = ({ open, isLoading, onClose, onSubmit }: UploadCandidateModalProps) => {
  const { addToast } = useContext(ToastContext);
  const form = useForm<CandidatesFormInputs>();
  const { handleSubmit: formHandleSubmit } = form;

  const onError = () => addToast({ type: ToastTypeEnum.ERROR });

  const handleSubmit = async (formData: CandidatesFormInputs) => {
    const cvFiles = formData.cvFiles.map((file) => file.file);

    onSubmit(cvFiles);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='md'>
      <Stack
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'>
        <Box />
        <DialogTitle
          variant='h5'
          sx={{ fontWeight: 500, paddingBottom: 0 }}>
          Загрузка кандидатов
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Typography
          textAlign='center'
          sx={{ marginBottom: 1 }}>
          Загрузите pdf файлы резюме кандидатов
        </Typography>
        <Form form={form}>
          <UploadButton
            name='cvFiles'
            label='Загрузить файлы'
            accept='application/pdf'
            rules={{ required: "Обязательное поле" }}
          />
        </Form>
      </DialogContent>
      <DialogActions>
        <Stack
          direction='row'
          spacing={2}>
          <Button
            variant='outlined'
            color='secondary'
            onClick={onClose}>
            Отменить
          </Button>
          <LoadingButton
            onClick={formHandleSubmit(handleSubmit, onError)}
            loading={isLoading}
            variant='contained'>
            Загрузить
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default UploadCandidateModal;
